import { appStore } from '../../../index'
import { Pages } from '../../../Stores/AppStore'
import { Button, Container } from '../../UI'
import * as React from 'react'
import classes from './PreviousAssignment.module.css'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import DateTimeService from '../../../Services/DateTimeService'
import { LNG } from '../../../Services/LanguageService';

export const PreviousAssignment = observer(() => {
  useEffect(() => {
    void appStore.getAssignmentHistory()
    return () => {
      appStore.clearAssignmentHistory()
    }
  }, [])

  const _onDoneClick = () => {
    appStore.setPage(Pages.Home)
  }
  return (
    <Container actions={<Button label={LNG.Text('scannerApp.22')} onClick={_onDoneClick}/>} showLoader={appStore.dataLoader.isPending}>
      <div className={classes.root}>
        <div className={classes.title}>{LNG.Text('scannerApp.5')}</div>
        <div className={classes.list}>
          <div className={classes.scroll}>
            {appStore.assignmentHistory.map(e => {
              const createdDate = e.createdAt ? DateTimeService.fromString(e.createdAt) : new Date()
              return <div
                key={e.id}
                className={classes.item}
                onClick={appStore.showAssignmentDetails(e)}
              >{DateTimeService.formatLocal(createdDate)} - {DateTimeService.formatLocal(createdDate, 'HH:mm')} - {e.rid}</div>
            })}
          </div>
        </div>
      </div>
    </Container>
  )
})
